import { activityCategories, activityCategoryForTouchpointType, } from "./activity-category";
export const unknownActivityTypeLabel = "Unknown activity type";
export const categoryActivityTarget = (category) => ({
    kind: "category",
    category,
});
export const taskTypeActivityTarget = (taskTypeId) => ({
    kind: "taskType",
    taskTypeId,
});
const categoryPrefix = "category:";
const taskTypePrefix = "taskType:";
export const serializeActivityTarget = (target) => {
    switch (target.kind) {
        case "category":
            return `${categoryPrefix}${target.category}`;
        case "taskType":
            return `${taskTypePrefix}${target.taskTypeId}`;
    }
    const exhaustiveCheck = target;
    throw new Error(`Unhandled activity target ${String(exhaustiveCheck)}`);
};
const isActivityCategory = (value) => activityCategories.includes(value);
const taskTypeIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const asActivityCategory = (value) => isActivityCategory(value) ? value : "other";
export const parseActivityTarget = (value) => {
    if (value.startsWith(categoryPrefix)) {
        const category = value.slice(categoryPrefix.length);
        return isActivityCategory(category) ? categoryActivityTarget(category) : null;
    }
    if (value.startsWith(taskTypePrefix)) {
        const taskTypeId = value.slice(taskTypePrefix.length);
        return taskTypeIdPattern.test(taskTypeId)
            ? taskTypeActivityTarget(taskTypeId)
            : null;
    }
    return null;
};
export const activityTargetFromView = (view) => {
    switch (view.kind) {
        case "category":
            return categoryActivityTarget(view.category);
        case "taskType":
            return taskTypeActivityTarget(view.taskTypeId);
    }
    const exhaustiveCheck = view;
    throw new Error(`Unhandled activity target view ${String(exhaustiveCheck)}`);
};
export const serializeActivityTargetView = (view) => serializeActivityTarget(activityTargetFromView(view));
export const allCategoryTargets = () => activityCategories.map(categoryActivityTarget);
export const isAnySelected = (targets) => {
    const keys = new Set(targets.map(serializeActivityTarget));
    return (keys.size === activityCategories.length &&
        activityCategories.every(category => keys.has(serializeActivityTarget(categoryActivityTarget(category)))));
};
export const parseActivityTargets = (values) => values
    .map(parseActivityTarget)
    .filter((target) => target !== null);
export const activityTargetForTouchpointKind = (kind) => categoryActivityTarget(activityCategoryForTouchpointType[kind]);
//# sourceMappingURL=activity-target.js.map